"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _SourceListImageFileItemBody = require("./SourceListImageFileItemBody.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PDF = require("../PDF");
require("react-pdf/dist/esm/Page/AnnotationLayer.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SourceListPdfFileItemBody = function SourceListPdfFileItemBody(_ref) {
  var value = _ref.value,
    onPresentationLoadSuccess = _ref.onPresentationLoadSuccess;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isDocumentLoaded = _useState2[0],
    setDocumentLoaded = _useState2[1];
  var url = value.url;
  var onDocumentLoad = function onDocumentLoad() {
    var pdf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      numPages: 0
    };
    var numPages = pdf.numPages;
    if (numPages > 0) {
      onPresentationLoadSuccess(pdf);
    }
    setDocumentLoaded(true);
  };
  return /*#__PURE__*/_react["default"].createElement(_SourceListImageFileItemBody.ImageViewer, null, /*#__PURE__*/_react["default"].createElement(_PDF.StudioPDFDocument, {
    onLoadSuccess: onDocumentLoad,
    key: url,
    file: url,
    className: "document"
  }, isDocumentLoaded && /*#__PURE__*/_react["default"].createElement(_PDF.StudioPDFPage, {
    pageNumber: 1,
    height: 110,
    className: "page",
    canvasBackground: "#ffffff"
  })));
};
SourceListPdfFileItemBody.propTypes = {
  value: _propTypes["default"].shape({
    url: _propTypes["default"].string
  }),
  onPresentationLoadSuccess: _propTypes["default"].func
};
var _default = exports["default"] = SourceListPdfFileItemBody;